
import { Button } from "@/components/ui/button";
import { LoaderCircle } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface ArabicLoanInfoNoticesProps {
  isSubmitting: boolean;
}

export const ArabicLoanInfoNotices = ({ isSubmitting }: ArabicLoanInfoNoticesProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="space-y-6">
      <div className="text-sm text-gray-500">
        <p className="mb-2">
          بالضغط على "قدم طلبًا" ، أنت تقر بقراءة وقبول الشروط والأحكام الخاصة بنا
        </p>
        <p>
          ملاحظة: نضمن أمان وسرية جميع معلوماتك الشخصية.
        </p>
      </div>
      
      <Button
        type="submit"
        className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-3 mt-4 transition-all duration-300 transform hover:scale-[1.02] hover:shadow-md rounded-lg font-semibold text-lg h-14"
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <LoaderCircle className="ml-2 h-5 w-5 animate-spin" />
            جاري التقديم...
          </>
        ) : (
          "قارن عروض القروض"
        )}
      </Button>
    </div>
  );
};
